<div class="button-group">
  @if (params.context.componentParent.showRowInEditMode(params.node)) {
  <button mat-button (click)="cancel()" class="row-button" color="warn">
    <mat-icon class="fa-close"></mat-icon>
  </button>
  } @if (params.context.componentParent.showRowInEditMode(params.node)) {
  <button
    mat-button
    color="primary"
    acsStopPropagation
    (click)="setRowSelection()"
    class="row-button"
    [disabled]="isButtonDisabled()"
  >
    <mat-icon class="fa-check"></mat-icon>
  </button>
  } @if (params.context.componentParent.showRowInViewMode(params.node) &&
  params.context.componentParent.loadingNode !== params.node.id) {
  <button
    mat-button
    acsStopPropagation
    (click)="setRowSelection()"
    [disabled]="isButtonDisabled()"
    class="row-button edit-row-button"
  >
    <mat-icon class="fa-pencil"></mat-icon>
  </button>
  } @if (params.context.componentParent.loadingNode === params.node.id) {
  <em> Loading... </em>
  }
</div>
